/**
 * Title-case a person's first or last name for display.
 * Handles spaces and hyphenated parts (e.g. Jean-Pierre).
 */
export function formatNamePart(value: string | null | undefined): string {
  if (value == null || typeof value !== 'string') return '';
  const trimmed = value.trim();
  if (!trimmed) return '';

  const capWord = (w: string): string =>
    w.length === 0 ? '' : w.charAt(0).toUpperCase() + w.slice(1).toLowerCase();

  return trimmed
    .split(/\s+/)
    .map((word) =>
      word.includes('-') ? word.split('-').map(capWord).join('-') : capWord(word)
    )
    .join(' ');
}
